import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    file: String,
    filename: String,
    uploaded: Boolean,
  };

  async upload() {
    const result = await this.performUpload();
    if (!result.ok) {
      alert("Upload failed: " + result.error);
    }
  }

  async performUpload() {
    if (this.uploadedValue) return { ok: true };

    const button = this.element.querySelector("[data-action*='upload']");
    if (button) {
      button.style.width = button.offsetWidth + "px";
      button.disabled = true;
      button.innerHTML =
        '<span class="spinner-border spinner-border-sm" role="status"></span>';
    }

    const csrfToken = document.querySelector(
      "meta[name='csrf-token']",
    )?.content;

    try {
      const response = await fetch("/admin/maps/queue/upload", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          file: this.fileValue,
          filename: this.filenameValue,
        }),
      });
      const data = await response.json();
      if (data.status === "OK") {
        this.uploadedValue = true;
        if (button) button.remove();
        const badge = document.createElement("span");
        badge.className = "badge bg-green-lt";
        badge.textContent = "Uploaded";
        this.element
          .querySelector("[data-map-queue-row-badge]")
          .appendChild(badge);
        return { ok: true };
      } else {
        if (button) {
          button.disabled = false;
          button.innerHTML = "Upload";
        }
        return { ok: false, error: data.message || "Unknown error" };
      }
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.innerHTML = "Upload";
      }
      return { ok: false, error: String(error) };
    }
  }
}
